import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { InputRefNoDialog } from '@app/home';
import { EmailRecord } from '@app/_models/email-record';
import { InternalTrade } from '@app/_models/internal-trade';
import { JobStatus } from '@app/_models/job-status';
import { AlertService } from '@app/_services';
import { FunctionsService } from '@app/_services/functions.service';
import { RestService } from '@app/_services/rest.service';
import { MsalService } from '@azure/msal-angular';
import Swal from 'sweetalert2';
import { Mk3Instructions, NIBInstructions, NIBQuoteRequest, RRInstructions, RRQuoteRequest } from '@app/_helpers/constants';
import { UtilsService } from '@app/_services/utils.service';

@Component({
  selector: 'app-internal-trade-details',
  templateUrl: './internal-trade-details.component.html',
  styleUrls: ['./internal-trade-details.component.scss'],
})
export class InternalTradeDetailsComponent implements OnInit {
  isLoading = true;
  searchValue = '';
  instructionType:string[]=[];
  internalTrade!: InternalTrade;
  dataSourceForEmailRecords!: MatTableDataSource<any>;
  dataSourceEmailRecords!: MatTableDataSource<any>;
  displayedEmailRecordsColumns: string[] = [
    'refNo',
    'instructionTypeId',
    'attachmentName',
    'category',
    'clientFriendlyName',
    'startDate',
    'endDate',
    'dateSent',
    'sentBy',
    'jobCost',
    'statusId',
    'details',
    'viewDocument',
    'retract'
  ];

  @ViewChild(MatSort, { static: true }) matSort!: MatSort;
  inputDialogRef: any;
  jobStatusesArray: Array<JobStatus> = [];

  constructor(
    public restService: RestService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public functionsService: FunctionsService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public appComponent: AppComponent,
    private router: Router,
    private msalService: MsalService,
    private utils:UtilsService
  ) {}

  ngOnInit(): void {
    this.instructionType[1] = NIBInstructions;
    this.instructionType[2] = NIBQuoteRequest;
    this.instructionType[3] = RRInstructions;
    this.instructionType[4] = RRQuoteRequest;
    this.instructionType[5] = Mk3Instructions;
    this.restService
      .getInternalTrade(this.route.snapshot.params['internalTradeId'])
      .subscribe((data) => {
        this.internalTrade = { ...data[0] };
        this.getEmailRecords();

        this.restService
          .getJobStatuses()
          .subscribe((jobStatuses: JobStatus[]) => {
            this.jobStatusesArray = jobStatuses;
          });
      });
  }

  getEmailRecords() {
    this.isLoading = true;
    return this.restService
      .getEmailRecordsByInternalTradeId(
        this.route.snapshot.params.internalTradeId
      )
      .subscribe(
        (emailRecords: any) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceEmailRecords.filteredData.forEach(item => {
            item.jobStatus = this.getJobStatus(item.statusId);
            item.instructionType = this.instructionType[item.instructionTypeId];
          });
          this.dataSourceForEmailRecords = this.dataSourceEmailRecords;
          this.dataSourceEmailRecords.filter = this.searchValue ? this.searchValue : '';
          this.dataSourceEmailRecords.sort = this.matSort;
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          //this.alertService.error(error);
          Swal.fire(
            'Error (Internal Trades): getEmailRecordsByInternalTradeId. Please contact the IT Department with details. Error: ' + error,
            '',
            'error'
          );
        }
      );
  }

  openInstructionPDF(emailRecordId: number) {
    this.restService.getEmailRecord(emailRecordId).subscribe(
      (data: EmailRecord) => {
        this.functionsService.openPdf(data.pdfData);
      },
      (error) => {
        //this.alertService.error(error);
        Swal.fire(
          'Error (Internal Trades): getDocument. Please contact the IT Department with details. Error: ' + error,
          '',
          'error'
        );
      }
    );
  }

  downloadPdf(base64String: any, fileName: string) {
    const source = base64String;
    const link = document.createElement('a');
    link.href = source;
    link.setAttribute('target', '_blank');
    link.download = fileName;
    link.click();
  }

  newWorkInstructions() {
    this.openInputRefNoDialog();
  }

  openInputRefNoDialog() {
    this.inputDialogRef = this.dialog.open(InputRefNoDialog, {
      minWidth: '400px',
      maxWidth: '1000px',
      data: {
        internalTrade: this.internalTrade,
        userName: this.appComponent.getUserName(),
        userEmail: this.appComponent.getUserEmail(),
      },
    });
  }

  jobDetails(jobId: number) {
    this.router.navigate(['../job-details/' + jobId], {
      queryParams: { internalTrade: true },
    });
  }

  async retract(emailRecordId: number) {
  this.isLoading = true;
   await this.utils.retractEmailRecord(emailRecordId,this.internalTrade.displayName,this.internalTrade.employeeId,'Internal Trades','instruction');
   this.isLoading = false;    
  }

  //Search by keyword
  onSearchKeyUp(search: { value: any }) {
    try {
        this.searchValue =search.value;
        var currentFilter = search.value;
        this.filterInstructions(currentFilter);
     
   } catch (error) {
     Swal.fire('Error in Search by keyword : ' + error, '', 'error');
   }
 }

 filterInstructions(currentFilter: string)
 {
  let result;
  if (currentFilter && currentFilter.length > 0) {
    this.isLoading = true;
    result = this.dataSourceForEmailRecords.filteredData.filter(item => (item.refNo != null && item.refNo.toString().includes(currentFilter)) || 
                                      (item.id != null && item.id.toString().includes(currentFilter)) || 
                                      (item.instructionType != null && item.instructionType.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.jobStatus != null && item.jobStatus.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.attachmentName != null && item.attachmentName.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.sentBy != null && item.sentBy.toLowerCase().includes(currentFilter.toLowerCase()))
                                   );
    this.dataSourceEmailRecords = new MatTableDataSource(result);
    this.isLoading = false;
   
  } else if (currentFilter == null || currentFilter.length == 0) {
    result = this.dataSourceForEmailRecords.filteredData;
    this.dataSourceEmailRecords = new MatTableDataSource(result);
    this.isLoading = false;
  }
 }

  //Clear search by keyword
  onClearClicked(search: { value: string }) {
    this.dataSourceForEmailRecords.filter = '';
    search.value ='';
    this.searchValue ='';
    this.dataSourceEmailRecords = new MatTableDataSource(this.dataSourceForEmailRecords.filteredData);
       this.isLoading = false;
  }

  getJobStatus(statusId: number) {
    return this.jobStatusesArray.find((item) => item.id == statusId)
      ?.description;
  }
}
